<template>
  <div class="header-bd">
    <div class="ub-f1">
      <t-paths></t-paths>
    </div>
    <!-- 消息 -->
    <div class="head-info">
      <div class="timer" @click="asyncLanguage()">
        <h2 v-if="serviceTime">
          {{ $t('components_header.fu_wu_qi_shi_jian') }}{{ momentAmPm(serviceTime) }} {{ userInfo.timeZoneName }}
          <span v-if="timeZoneShort && timeZoneIdList.length > 1">{{ timeZoneShort }}</span>
        </h2>
      </div>
      <!-- bodyNum搜索 -->
      <div class="header-search-hd">
        <el-autocomplete
          v-model="bodyNum"
          :fetch-suggestions="querySearchAsync"
          :placeholder="$t('components_header.ji_shen_hao_hou4wei')"
          @select="handleSelect"
          style="width: 100%"
          clearable
          :hide-loading="!!bodyNum"
          :trigger-on-focus="false"
        ></el-autocomplete>
      </div>
      <!-- APP下载 -->
      <el-popover placement="bottom" :title="$t('components_header.azAPPazb')" width="410" trigger="hover">
        <div slot="reference" class="myapp"><i class="icon icon-app"></i></div>
        <div class="ub">
          <div class="ub-f1">
            <h1 style="text-align: center; margin: 8px 0 10px; font-weight: bold">ICE Care APP</h1>
            <div style="text-align: center">
              <qrcode-vue :value="aSAppResPath" :size="144"></qrcode-vue>
              <div style="line-height: 24px; font-size: 13px">{{ $t('components_header.ban_ben_haoo', [aSAppVersion]) }}</div>
            </div>
          </div>
          <div style="width: 16px"></div>
          <div class="ub-f1">
            <h1 style="text-align: center; margin: 8px 0 10px; font-weight: bold">i-Synergy APP</h1>
            <div style="text-align: center">
              <qrcode-vue :value="csAppResPath" :size="144"></qrcode-vue>
              <div style="line-height: 24px; font-size: 13px">{{ $t('components_header.ban_ben_haoo', [csAppVersion]) }}</div>
            </div>
          </div>
        </div>
        <p style="text-align: center; margin: 10px 0 10px">{{ $t('components_header.smewmxz') }}</p>
      </el-popover>
      <div class="examine" @click="jump('/operation')" v-if="isOperationAuth">
        <i class="icon icon-yunweijilu"></i>
      </div>
      <div class="examine" @click="jump('/examine/myApproval')" v-if="isApprovalAuth">
        <i class="icon icon-renzheng"></i>
      </div>
      <div class="search" @click="jump('/waitdevice')" v-if="isWaitDeviceAuth">
        <i class="icon icon-fenpei"></i>
      </div>
      <div class="message" @click="jump('/msg/center')">
        <div class="message-num" v-if="messageNum">
          <el-badge :value="messageNum"></el-badge>
        </div>
        <i class="icon icon-xiaoxi"></i>
      </div>
      <!-- 语种选择 -->
      <el-dropdown>
        <h1>{{ langName }}</h1>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in languageTypes" :key="index">
            <div @click="changeLang(item)">{{ item.name }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 头像 -->
      <div class="head-img">
        <img src="../images/layout/default_head.png" alt />
        <div class="introduction fade-enter-active">
          <div class="user-box">
            <img src="../images/layout/default_head.png" alt />
            <div class="user-name">
              <p class="name">{{ this.$store.state.userInfo.realName || this.$store.state.userInfo.userName }}</p>
              <p class="organization">{{ this.$store.state.userInfo.rootOrgName }}</p>
            </div>
          </div>
          <div class="operating">
            <div @click="jump('/userset')">{{ $t('components_header.ge_ren_zhong_xin') }}</div>
            <div @click="changePwdDialog">{{ $t('components_header.xiu_gai_mi_ma') }}</div>
          </div>
          <div class="signout-box">
            <div class="signout" @click="signout">{{ $t('components_header.tui_chu_deng_lu') }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--修改密码 -->
    <usersetResetPassword v-if="visible" @close="visible = false"></usersetResetPassword>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import QrcodeVue from 'qrcode.vue';
import usersetResetPassword from '@/pages/base/components/resetPwdDialog.vue';
import tPaths from './paths.vue';
import locale from '../locales/locale.json';
import { setLocale } from '../locales';

export default {
  components: { QrcodeVue, tPaths, usersetResetPassword },
  data() {
    return {
      timeZoneIdList: [],
      serviceTime: '',
      timeZoneShort: '',
      languageTypes: [],
      showTheme: false,
      themeList: [
        {
          label: '',
          value: '',
          bgColor: '#0D9AE0', // 默认主题
        },
        {
          label: 'theme2',
          value: 'custom-546EE7',
          bgColor: '#546EE7',
        },
      ],
      langCode: '',
      themeColor: '',

      messageWebSocket: null,
      userHover: false, // 用户信息hover
      visible: false, // 修改密码

      timerShow: null,
      timerHide: null,
      csAppResPath: '',
      csAppVersion: '',
      aSAppResPath: '',
      aSAppVersion: '',
      isOperationAuth: false,
      isApprovalAuth: false,
      isWaitDeviceAuth: true,

      msgStatistics: 0,
      // bodyNum搜索
      restaurants: [],
      bodyNum: '',
    };
  },
  mounted: function () {
    this.langCode = Cookies.get('langCode');
    this.getLangList();
    this.getMsgStatistics();
    this.getTimeZoneIdList();
    this.initWebSocket();
    // 获取未读消息
    this.getAppVersion();
    this.getFuncView('/operation', (data) => {
      this.isOperationAuth = !!data.operations_list || !!data.schedules_list;
    });
    this.getFuncView('/examine/myApproval', (data) => {
      this.isApprovalAuth = !!data.approval_list;
    });
    this.getFuncView('/waitdevice', (data) => {
      this.isWaitDeviceAuth = !!data.distribution_device;
    });
  },
  computed: {
    langName() {
      const item = this.languageTypes.find((t) => t.value === this.langCode) || {};
      return item.name;
    },
    messageNum() {
      return this.$store.state.messageNum;
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  destroyed: function () {
    this.messageWebSocket.closeMyself();
    this.messageWebSocket = null;
  },
  methods: {
    // 等待执行
    sleep: async function (time) {
      return new Promise((resolve) => {
        setInterval(() => {
          resolve();
        }, time);
      });
    },
    // 同步多语言
    asyncLanguage: async function () {
      if (process.env.NODE_ENV !== 'development') {
        return;
      }
      const groupCodes = Object.keys(locale);
      /* eslint-disable */
      console.warn('------  多语言同步开始  --------');
      for (let i = 0; i <= groupCodes.length - 1; i++) {
        const groupCode = groupCodes[i];
        /* eslint-disable */
        console.warn(`《${groupCode}》多语言同步中....`);
        const regex = /^(base|dms|crm|asm|fms|training|report)_/;
        const appCodeMap = { base: 'bas', report: 'sta' };
        const appCodes = groupCode.match(regex);
        if (appCodes) {
          const appCode = appCodes[1];
          // if (appCode === 'crm') {
          const langKey = locale[groupCode];
          delete langKey.__filePath;
          delete langKey.__title;
          console.log(langKey);
          this.$postJSON(apis.LanguageSyncCompApp, { appCode: appCodeMap[appCode] || appCode, groupCode, langKey, langData: { EN: undefined, TW: undefined } });
          await this.sleep(100);
          // }
        } else {
          const appCode = 'isynergy_cloud';
          const langKey = locale[groupCode];
          delete langKey.__filePath;
          delete langKey.__title;
          this.$postJSON(apis.LanguageSyncCompApp, { appCode, groupCode, langKey, langData: { EN: undefined, TW: undefined } });
          await this.sleep(100);
        }
        /* eslint-disable */
        console.warn(`《${groupCode}》完成`);
      }
      /* eslint-disable */
      console.warn('------  多语言同步结束  --------');
    },

    runServiceTime(timer) {
      const utcOffset = this.$moment.utc(timer).diff(this.$moment.utc(), 'seconds');
      this.timeInterval = setInterval(() => {
        this.serviceTime = this.$momentLocal(this.$moment.utc().add(utcOffset, 's'));
      }, 1000);
    },
    getAppVersion: function () {
      this.$getJSON(apis.AppCsVersion, {
        appOs: 'android',
        currentVersion: '1.0.0',
      }).then((res) => {
        this.csAppResPath = res.data.resPath;
        this.csAppVersion = res.data.versionCode;
      });
      this.$getJSON(apis.AppAsVersion, {
        appOs: 'android',
        currentVersion: '1.0.0',
      }).then((res) => {
        this.aSAppResPath = res.data.resPath;
        this.aSAppVersion = res.data.versionCode;
      });
    },
    initWebSocket: function () {
      // ws:// 82.157.123.54:9010/ajaxchattest
      // 493058936701386752
      const userId = this.$store.state.userInfo.userId;
      const domain = document.domain;
      // 线上地址 /ice/websocket/{userId}
      // 本地地址`ws://192.168.11.130:8421/websocket/${userId}`
      if (this.isDev) {
        this.messageWebSocket = this.$connectWebSocketClass(`ws://192.168.11.130:8421/websocket/${userId}`, this.wsClassBack, 'messageWebSocket'); //
      } else {
        this.messageWebSocket = this.$connectWebSocketClass(`ws://${domain}/ice/websocket/${userId}`, this.wsClassBack, 'messageWebSocket'); //
      }
      const tips = this.$t('components_header.ljyfwqtx');
      this.messageWebSocket.connect(tips); // 连接服务器
    },
    // 获取未读消息
    getMsgStatistics() {
      this.$getJSON(apis.msgRecordTotalInit).then((res) => {
        this.runServiceTime(res.data.sysTime);
        this.timeZoneShort = (res.data.timeZoneDto && res.data.timeZoneDto.timeZoneShort) || '';
        // 刷新未读消息数
        const count = res.data.unReadCounts.totalCounts || 0;
        this.msgStatistics = count;
        this.$store.commit('MESSAGEWS', this.msgStatistics);
      });
    },
    getTimeZoneIdList: function () {
      this.$getJSON(apis.timeZoneGetCompanyList).then((res) => {
        this.timeZoneIdList = res.data;
      });
    },
    // 实时消息回调
    // 接受服务器推送的data
    wsClassBack() {
      // console.log('接收', data);
      // this.$store.commit('MESSAGEWS');
      this.msgStatistics++;
      this.$store.commit('MESSAGEWS', this.msgStatistics);
      // 消息提示
      // 暂时不用弹窗
      // const h = this.$createElement;
      // const ctx = JSON.parse(data);
      // this.$notify({
      //   title: ctx.title || '',
      //   message: h('i', { style: 'color: #6C757D' }, ctx.content || ''),
      //   // type: 'warning',
      //   duration: 3000,
      //   position: 'top-right',
      //   onClick: () => {
      //     this.jump('/msg/center');
      //   },
      // });
    },

    changePwdDialog: function () {
      this.visible = true;
    },
    changeTheme: function (item) {
      this.showTheme = false;
      this.$store.commit('THEMECOLOR', item.value);
      document.body.className = item.value;
      document.body.setAttribute('data-theme', item.label);
    },
    // 获取多语言列表
    getLangList: function () {
      this.$getJSON(apis.DictionaryCode, { groupCodes: 'language_type' }).then((res) => {
        this.languageTypes = res.data.language_type || [];
      });
    },
    // 切换语言
    changeLang: function (item) {
      if (item.value !== this.langCode) {
        setLocale(item.value);
        this.$router.go(0);
      }
    },
    // 退出登录
    signout: function () {
      this.$postJSON(apis.Logout).finally(() => {
        this.$store.commit('LOGINOUT');
        Cookies.remove('loginName', { path: '/' });
        Cookies.remove('token', { path: '/' });
        Cookies.remove('nonMetric', { path: '/' });
        Cookies.remove('tokenTimeOut', { path: '/' });
        this.$router.replace({ path: '/login', query: {} });
      });
    },

    // bodyNum搜索
    querySearchAsync(bodyNum, cb) {
      // var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter() : restaurants;
      if (bodyNum) {
        // `${ }/${bodyNum}`
        this.$getJSON(apis.deviceGlobalList, { bodyNum }).then((res) => {
          const list = res.data.map((item) => ({ ...item, value: `${item.bodyNum} ${item.productCode}` }));
          cb(list);
        });
      }
    },

    handleSelect(row) {
      this.bodyNum = row.bodyNum;
      this.jump('/devicedetail', { bodyNum: row.bodyNum, parentPath: this.$route.path });
    },
  },
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.header-bd {
  height: 50px;
  display: flex;
  z-index: 9;
  position: relative;
  background: #ffffff;
  box-shadow: 0px 0.5px 4px 0px rgba(0, 21, 41, 0.12);
  .el-color-picker__color-inner {
    @include background_color_main();
  }

  .el-color-picker__trigger {
    width: 32px;
    height: 32px;
    margin-right: 5px;
    margin-left: 5px;
    margin-top: 9px;
  }

  .organ {
    line-height: 50px;
    .icon {
      float: left;
      font-size: 17px;
      color: #70de5a;
      margin-right: 8px;
    }
    h1 {
      color: #415159;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .head-info {
    margin-right: 4px;
    display: flex;
    height: 50px;
    line-height: 50px;
    .timer {
      font-size: 12px;
      margin-right: 24px;
      color: #6c757d;
    }
    .myapp {
      cursor: pointer;
      margin-right: 16px;
      .icon {
        font-size: 16px;
        color: #415159;
      }
    }
    .examine {
      cursor: pointer;
      margin-right: 16px;
      .icon {
        font-size: 17px;
        color: #415159;
      }
    }
    .search {
      cursor: pointer;
      margin-right: 16px;
      .icon {
        font-size: 15px;
        color: #415159;
      }
    }
    .message {
      cursor: pointer;
      margin-right: 10px;
      position: relative;
      .message-num {
        position: absolute;
        top: -9px;
        right: -12px;
      }
      .icon {
        font-size: 17px;
        color: #415159;
      }
    }
    h1 {
      font-size: 12px;
      color: #415159;
      padding: 0 16px;
      min-width: 70px;
      text-align: center;
    }
    .head-img {
      width: 44px;
      height: 40px;
      font-size: 0;
      text-align: center;
      margin-top: 10px;
      position: relative;
      &:hover {
        .introduction {
          display: block;
        }
      }
      img {
        display: inline-block;
        width: 30px;
        height: 30px;
      }
      @keyframes fadeshow {
        0% {
          transform: translate3d(0, 100%, 0);
          opacity: 0;
        }
        100% {
          transform: translate3d(0, 0, 0);
          opacity: 1;
        }
      }
      @keyframes fadehide {
        0% {
          transform: translate3d(0, 0, 0);
          opacity: 1;
        }
        100% {
          transform: translate3d(0, -100%, 0);
          opacity: 0;
        }
      }
      .fade-enter-active {
        animation: fadeshow 0.3s;
      }
      .fade-leave-active {
        animation: fadehide 0.3s;
      }

      .introduction {
        width: 270px;
        background-color: #ffffff;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        position: absolute;
        right: -4px;
        top: 37px;
        display: none;
        .user-box {
          height: 66px;
          padding: 0 12px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #f2f3fb;
        }
        img {
          width: 38px;
          height: 38px;
          margin-right: 13px;
          flex: 0 0 38px;
        }
        .user-name {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          text-align: left;
          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(73, 80, 87, 1);
            line-height: 17px;
            height: 21px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .organization {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(108, 117, 125, 1);
            line-height: 17px;
            height: 17px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .operating {
          padding: 20px 14px;
          display: flex;
          div {
            flex: 1;
            height: 18px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(108, 117, 125, 1);
            line-height: 18px;
            text-align: center;
            cursor: pointer;
          }
          div:first-of-type {
            border-right: 1px solid #e9ebec;
          }
        }
        .signout-box {
          padding: 0 14px 14px;
          .signout {
            text-align: center;
            background-color: #f5f5f5;
            width: 100%;
            height: 30px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(13, 154, 224, 1);
            line-height: 30px;
            border-radius: 2px;
            cursor: pointer;
          }
        }
      }
    }
    .header-search-hd {
      margin: 9px 24px 0 0;
      width: 190px;
      line-height: 32px;
    }
  }
}
</style>
